// src/pages/HomeRedirect.jsx
import React, { useMemo } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { NIVEIS } from "../config/niveis";

export default function HomeRedirect() {
  const { usuario } = useAuth();

  const nivel = useMemo(() => Number(usuario?.nivel ?? -1), [usuario]);
  const isKiosk = nivel === NIVEIS.KIOSK;

  // Kiosk: abre a tela inicial de configuracao do kiosk
  if (isKiosk) {
    return <Navigate to="/ordens-servico/kiosk" replace />;
  }

  // Mantém o comportamento atual
  if (window.location.pathname.startsWith("/manut")) {
    return <Navigate to="/ordens-servico/abrir-nova-os" replace />;
  }
  if (window.location.pathname.startsWith("/estoque")) {
    return <Navigate to="/estoque/entrada" replace />;
  }
  if (window.location.pathname.startsWith("/financeiro")) {
    return <Navigate to="/financeiro" replace />;
  }

  return <Navigate to="/dashboard" replace />;
}
